/**
 * NextEpisodeContentContainer component.
 */
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled next episode content container.
 */
const NextEpisodeContentContainer = styled.div<Props>`
  align-items: center;
  display: flex;
  height: 100%;
  padding: 0 ${(props) => (props.focused ? 22 : 20) * Screen.widthRatio}px;

  &:hover {
    padding: 0 ${22 * Screen.widthRatio}px;
  }
`;

export default NextEpisodeContentContainer;
